import React from "react";

/**
 * Small square icon action for a dock header.
 *
 * @param {Object} props
 * @param {React.ComponentType<{className?: string}>} props.Icon
 * @param {string} props.label - Accessible name and tooltip.
 * @param {() => void} props.onClick
 * @param {string} [props.className]
 */
export function DockIconButton({ Icon, label, onClick, className = "" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
      className={`rounded-lg p-1.5 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-900 active:bg-gray-200 ${className}`}
    >
      <Icon className="h-4 w-4" aria-hidden="true" />
    </button>
  );
}

export default DockIconButton;
